import dayjs from "dayjs";

import {
  TRANG_THAI_HANG_HOA,
  TRANG_THAI_NCC,
  TRANG_THAI_PHIEU_DE_XUAT_NVL,
} from "../freezes";

export const TRANG_THAI_HANG_HOA_OPTIONS = [
  {
    id: TRANG_THAI_HANG_HOA.MOI_TAO,
    value: TRANG_THAI_HANG_HOA.MOI_TAO,
    label: "Mới tạo",
  },
  {
    id: TRANG_THAI_HANG_HOA.TRONG_MENU,
    value: TRANG_THAI_HANG_HOA.TRONG_MENU,
    label: "Đã trong menu",
  },
  {
    id: TRANG_THAI_HANG_HOA.NGUNG,
    value: TRANG_THAI_HANG_HOA.NGUNG,
    label: "Ngưng",
  },
];

export const KY_DANH_GIA_OPTIONS = Array(20)
  .fill("")
  .map((e, index) => ({ value: index + 1, label: index + 1 }));

let YEAR_OPTIONS = [];
const currentYear = dayjs().year();
const minYear = currentYear - 20;
const maxYear = currentYear + 30;

for (let i = minYear; i < maxYear; i++) {
  YEAR_OPTIONS.push({ value: i, label: i });
}

export { YEAR_OPTIONS };

export const TRANG_THAI_PHIEU_DE_XUAT_NVL_OPTIONS = [
  {
    id: TRANG_THAI_PHIEU_DE_XUAT_NVL.REJECT,
    value: TRANG_THAI_PHIEU_DE_XUAT_NVL.REJECT,
    label: "Không duyệt",
  },
  {
    id: TRANG_THAI_PHIEU_DE_XUAT_NVL.WAREHOUSE_CENTER,
    value: TRANG_THAI_PHIEU_DE_XUAT_NVL.WAREHOUSE_CENTER,
    label: "Chờ kho trung tâm duyệt",
  },
  {
    id: TRANG_THAI_PHIEU_DE_XUAT_NVL.WAREHOUSE_CENTER_BEYER,
    value: TRANG_THAI_PHIEU_DE_XUAT_NVL.WAREHOUSE_CENTER_BEYER,
    label: "Chờ kho trung tâm 2 duyệt",
  },
  {
    id: TRANG_THAI_PHIEU_DE_XUAT_NVL.IC,
    value: TRANG_THAI_PHIEU_DE_XUAT_NVL.IC,
    label: "Chờ IC duyệt",
  },
  {
    id: TRANG_THAI_PHIEU_DE_XUAT_NVL.ACCOUNTANT,
    value: TRANG_THAI_PHIEU_DE_XUAT_NVL.ACCOUNTANT,
    label: "Chờ kề toán duyệt",
  },
  {
    id: TRANG_THAI_PHIEU_DE_XUAT_NVL.OPERATOR,
    value: TRANG_THAI_PHIEU_DE_XUAT_NVL.OPERATOR,
    label: "Chờ giám đốc duyệt",
  },
  {
    id: TRANG_THAI_PHIEU_DE_XUAT_NVL.DONE,
    value: TRANG_THAI_PHIEU_DE_XUAT_NVL.DONE,
    label: "Đã duyệt",
  },
];

export const TRANG_THAI_NCC_OPTIONS = [
  {
    id: TRANG_THAI_NCC.DANG_CUNG_CAP,
    value: TRANG_THAI_NCC.DANG_CUNG_CAP,
    label: "Đã cung cấp",
  },
  {
    id: TRANG_THAI_NCC.NGUNG_CUNG_CAP,
    value: TRANG_THAI_NCC.NGUNG_CUNG_CAP,
    label: "Ngưng cung cấp",
  },
];
